<template>
    <div>
        <!-- 标题 -->
        <div class="modal-header">
            <div class="modal-title">
                <a-icon type="medicine-box" style="margin-right:10px" />
                <span>{{entity.name + l('Settings')}}</span>
            </div>
        </div>
        <a-config-provider :locale="antdLocale">
			<a-card>
				<a-col :span="18">
					<a-row style="margin-bottom: 10px;">
					    <a-col :span="10">
					        <a-button type="primary" @click="handleAdd()">
					            <a-icon type="plus"/>
					            {{l('Create')}}
					        </a-button>
					    </a-col>
						<a-col :span="14" style="text-align: right;">
							<a-input-search v-model.trim="searchKeyword" placeholder="请输入关键字" allowClear
								style="width: 220px;" @change="onSearchChange" />
						</a-col>
					</a-row>
					<a-spin :spinning="isLoading">
						<a-table :columns="columns"
								 :data-source="visibleTableData"
								 :rowKey="(record)=>record.id"
								 :pagination="false"
								 :scroll="{x: 690,y:500}"
								 @change="onTableChange"
								 size="small"
						>
							<template v-for="(item,index) in parameterList" :slot="item.dataIndex" slot-scope="text, record, index">
								<div>
									<a-input v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChange(e.target.value, record, item.dataIndex)"/>
									<span v-else>
										{{text}}
									</span>
								</div>
							</template>
							<span slot="action" slot-scope="text,record">
								<span v-if="record.editable">
									<a @click="() => saveEditable(record)">{{l('Save')}}</a>
									<a-popconfirm :title="l('Whether_to_cancel_editing?')" @confirm="() => cancel(record)" style="margin-left: 10px;">
										<a>{{l('Cancel')}}</a>
									</a-popconfirm>
								</span>
								<a @click.stop="edit(record)" v-else>{{l('Edits')}}</a>
								<a @click.stop="onDelete(record)" v-if="!record.editable" style="margin-left: 10px;color: red">{{l('Delete')}}</a>
							</span>
						</a-table>
					</a-spin>
					<a-pagination :current="currentPage" :pageSize="pageSize" :total="filteredTableData.length"
						showSizeChanger showQuickJumper :pageSizeOptions="['20', '50', '100']"
						@change="onPageChange" @showSizeChange="onPageSizeChange" />
				</a-col>
				<a-col :span="5" style="margin-left: 20px;">
					<h3 style="margin-top: 45px;">{{l('Parameter_Description')}}</h3>
					<div style="width: 100%" v-for="(item,index) in parameter">
						<div>{{l('Name') + "：" + item.text}}</div>
						<div>{{l('Parameters') + "：" + item.paramName}}</div>
						<div style="margin-bottom: 10px;">{{l('Remark') + "：" + item.remark}}</div>
					</div>
				</a-col>
			</a-card>
        </a-config-provider>
        <!-- 按钮 -->
        <div class="modal-footer" v-if="!isLook">
            <a-button @click="close">
                {{l('Cancel')}}
            </a-button>
            <a-button :type="'primary'" @click="save">
                {{l('Save')}}
            </a-button>
        </div>
    </div>
</template>

<script>
	import ModalComponentBase from '../../../../shared/component-base/modal-component-base';
	import zh_CN from 'ant-design-vue/lib/locale/zh_CN';
	import { KanBanServiceProxy } from '../../../../shared/service-proxies';
	
	let _this;
	export default {
		name: 'Data-settings',
		mixins: [ModalComponentBase],
		components: {
		    
		},
		data() {
		    return {
		        zh_CN,
		        isEdit: false,
		        isLook: false,
		        id: undefined,
		        isLoading: false,//加载中
				entity: {},
				tableData: [],
				columns: [],
				parameterList: [],
				editingId: '',
				cacheData: [],
				parameter: [],
				pageNumber: 1,
				pageSize: 20,
				searchKeyword: '',
				sortField: null,
				sortOrder: null
		    }
		},
		computed: {
			currentPage() {
				return Math.min(this.pageNumber, Math.max(1, Math.ceil(this.filteredTableData.length / this.pageSize)));
			},
			filteredTableData() {
				const keyword = this.searchKeyword.trim().toLocaleLowerCase();
				if(!keyword) {
					return this.tableData;
				}
				const fields = this.parameter.map(item => item.paramName);
				return this.tableData.filter(record => record.editable || fields.some(field => {
					const value = record[field];
					return value != null && String(value).toLocaleLowerCase().includes(keyword);
				}));
			},
			sortedTableData() {
				if(!this.sortField || !this.sortOrder) {
					return this.filteredTableData;
				}
				const direction = this.sortOrder === 'ascend' ? 1 : -1;
				return this.filteredTableData.map((item, index) => ({ item, index }))
					.sort((a, b) => {
						const left = a.item[this.sortField];
						const right = b.item[this.sortField];
						const leftEmpty = left == null || String(left).trim() === '';
						const rightEmpty = right == null || String(right).trim() === '';
						if(leftEmpty || rightEmpty) {
							return leftEmpty === rightEmpty ? a.index - b.index : leftEmpty ? 1 : -1;
						}
						const leftNumber = Number(left);
						const rightNumber = Number(right);
						const result = Number.isFinite(leftNumber) && Number.isFinite(rightNumber)
							? leftNumber - rightNumber
							: String(left).localeCompare(String(right), 'zh-CN', { numeric: true });
						return result === 0 ? a.index - b.index : result * direction;
					})
					.map(({ item }) => item);
			},
			visibleTableData() {
				const start = (this.currentPage - 1) * this.pageSize;
				return this.sortedTableData.slice(start, start + this.pageSize);
			}
		},
		created() {
		    _this = this;
		    this.fullData(); // 模态框必须,填充数据到data字段
			this.KanBanServiceProxy = new KanBanServiceProxy(this.$apiUrl, this.$api);
		},
		mounted() {
		    this.getData()
		},
		methods: {
			parseJsonArray(value) {
				if(!value) {
					return [];
				}
				let result = value;
				// 兼容历史数据中被重复 JSON 序列化的字段。
				for(let i = 0; i < 10 && typeof result === 'string' && result; i++) {
					result = JSON.parse(result);
				}
				if(!Array.isArray(result)) {
					throw new Error('数据格式错误');
				}
				return result;
			},
			onPageChange(page) {
				this.pageNumber = page;
			},
			onPageSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.pageNumber = 1;
			},
			onSearchChange() {
				this.pageNumber = 1;
			},
			onTableChange(pagination, filters, sorter) {
				this.sortField = sorter.order ? sorter.field : null;
				this.sortOrder = sorter.order || null;
				this.pageNumber = 1;
			},
		    save() {
				this.KanBanServiceProxy.createOrUpdate(
				    {
						...this.entity,
						value: JSON.stringify(this.tableData),
						paramDesc: JSON.stringify(this.parameter)
					}
				).finally(() => {
					
				}).then(res => {
				    this.success(true);
				})
		    },
			handleAdd() {
				let { tableData } = this;
				let newData = {};
				for(let i in this.parameter) {
					if(this.parameter[i].paramName === 'id') {
						newData[this.parameter[i].paramName] = this.tableData[this.tableData.length - 1].id + 1;
					}else {
						newData[this.parameter[i].paramName] = undefined;
					}
				}
				this.searchKeyword = '';
				this.tableData.push(newData);
				this.$nextTick(() => {
					const index = this.sortedTableData.indexOf(newData);
					this.pageNumber = Math.floor(index / this.pageSize) + 1;
				});
				// this.tableData = [...tableData, newData];
			},
			onDelete(value) {
				this.$confirm({
					title: this.l("ConfirmInformation"),
					content: this.l("the_selected_option"),
					cancelText: this.l('Cancel'),
					okText: this.l('Ok'),
					onOk: () => {
						let tableData = [...this.tableData];
						let name;
						let target;
						if(this.entity.code == "Departmental-Plan-Completion-Rate" || this.entity.code == "Departmental-Issue-Closure-Rate" || this.entity.code == "Departmental-Compliance-Rate") {
							name = value.departmentName;
							this.tableData = tableData.filter(item => item.departmentName !== name);
						}
						if(this.entity.code == "Plan-Completion-Rate" || this.entity.code == "Issue-Closure-Rate" || this.entity.code == "Compliance-Rate") {
							name = value.month;
							this.tableData = tableData.filter(item => item.month !== name);
						}
						if(this.entity.code == "Audit-Plan" || this.entity.code == "List-of-issues") {
							name = value.id;
							this.tableData = tableData.filter(item => item.id !== name);
						}
						if(this.entity.code == "Level") {
							name = value.levelName;
							this.tableData = tableData.filter(item => item.levelName !== name);
						}
						if(this.entity.code == "Issue-Area") {
							name = value.areaName;
							this.tableData = tableData.filter(item => item.areaName !== name);
						}
						if(this.entity.code == "Issue-Type") {
							name = value.issueType;
							this.tableData = tableData.filter(item => item.issueType !== name);
						}
						if(this.entity.code == "Departmental-hidden-dangers" || this.entity.code == "Key-positions" || this.entity.code == "Hazard-closure-rate" || this.entity.code == "Year-hazard-closure-rate") {
							name = value.id;
							this.tableData = tableData.filter(item => item.id !== name);
						}
					}
				})
			},
			edit(value) {
				let newData = [...this.tableData];
				let newCacheData = [...this.cacheData];
				let name;
				let target;
				let targetCache;
				if(this.entity.code == "Departmental-Plan-Completion-Rate" || this.entity.code == "Departmental-Issue-Closure-Rate" || this.entity.code == "Departmental-Compliance-Rate") {
					name = value.departmentName;
					target = newData.find(item => name === item.departmentName);
					targetCache = newCacheData.find(item => name === item.departmentName);
				}
				if(this.entity.code == "Plan-Completion-Rate" || this.entity.code == "Issue-Closure-Rate" || this.entity.code == "Compliance-Rate") {
					name = value.month;
					target = newData.find(item => name === item.month);
					targetCache = newCacheData.find(item => name === item.month);
				}
				if(this.entity.code == "Audit-Plan" || this.entity.code == "List-of-issues") {
					name = value.id;
					target = newData.find(item => name === item.id);
					targetCache = newCacheData.find(item => name === item.id);
				}
				if(this.entity.code == "Level") {
					name = value.levelName;
					target = newData.find(item => name === item.levelName);
					targetCache = newCacheData.find(item => name === item.levelName);
				}
				if(this.entity.code == "Issue-Area") {
					name = value.areaName;
					target = newData.find(item => name === item.areaName);
					targetCache = newCacheData.find(item => name === item.areaName);
				}
				if(this.entity.code == "Issue-Type") {
					name = value.issueType;
					target = newData.find(item => name === item.issueType);
					targetCache = newCacheData.find(item => name === item.issueType);
				}
				if(this.entity.code == "Departmental-hidden-dangers" || this.entity.code == "Key-positions" || this.entity.code == "Hazard-closure-rate" || this.entity.code == "Year-hazard-closure-rate") {
					name = value.id;
					target = newData.find(item => name === item.id);
					targetCache = newCacheData.find(item => name === item.id);
				}
				this.editingId = name;
				if (target) {
					target.editable = true;
					this.tableData = newData;
					Object.assign(targetCache, target);
					this.cacheData = newCacheData;
				}
			},
			saveEditable(value) {
				let newData = [...this.tableData];
				let name;
				let target;
				if(this.entity.code == "Departmental-Plan-Completion-Rate" || this.entity.code == "Departmental-Issue-Closure-Rate" || this.entity.code == "Departmental-Compliance-Rate") {
					name = value.departmentName;
					target = newData.find(item => name === item.departmentName);
				}
				if(this.entity.code == "Plan-Completion-Rate" || this.entity.code == "Issue-Closure-Rate" || this.entity.code == "Compliance-Rate") {
					name = value.month;
					target = newData.find(item => name === item.month);
				}
				if(this.entity.code == "Audit-Plan" || this.entity.code == "List-of-issues") {
					name = value.id;
					target = newData.find(item => name === item.id);
				}
				if(this.entity.code == "Level") {
					name = value.levelName;
					target = newData.find(item => name === item.levelName);
				}
				if(this.entity.code == "Issue-Area") {
					name = value.areaName;
					target = newData.find(item => name === item.areaName);
				}
				if(this.entity.code == "Issue-Type") {
					name = value.issueType;
					target = newData.find(item => name === item.issueType);
				}
				if(this.entity.code == "Departmental-hidden-dangers" || this.entity.code == "Key-positions" || this.entity.code == "Hazard-closure-rate" || this.entity.code == "Year-hazard-closure-rate") {
					name = value.id;
					target = newData.find(item => name === item.id);
				}
				if (target) {
					delete target.editable;
					this.tableData = newData;
				}
				this.editingKey = '';
			},
			cancel(value) {
				let newData = [...this.tableData];
				let name;
				let target;
				if(this.entity.code == "Departmental-Plan-Completion-Rate" || this.entity.code == "Departmental-Issue-Closure-Rate" || this.entity.code == "Departmental-Compliance-Rate") {
					name = value.departmentName;
					target = newData.find(item => name === item.departmentName);
				}
				if(this.entity.code == "Plan-Completion-Rate" || this.entity.code == "Issue-Closure-Rate" || this.entity.code == "Compliance-Rate") {
					name = value.month;
					target = newData.find(item => name === item.month);
				}
				if(this.entity.code == "Audit-Plan" || this.entity.code == "List-of-issues") {
					name = value.id;
					target = newData.find(item => name === item.id);
				}
				if(this.entity.code == "Level") {
					name = value.levelName;
					target = newData.find(item => name === item.levelName);
				}
				if(this.entity.code == "Issue-Area") {
					name = value.areaName;
					target = newData.find(item => name === item.areaName);
				}
				if(this.entity.code == "Issue-Type") {
					name = value.issueType;
					target = newData.find(item => name === item.issueType);
				}
				if(this.entity.code == "Departmental-hidden-dangers" || this.entity.code == "Key-positions" || this.entity.code == "Hazard-closure-rate" || this.entity.code == "Year-hazard-closure-rate") {
					name = value.id;
					target = newData.find(item => name === item.id);
				}
				this.editingKey = '';
				if (target) {
					if(this.entity.code == "Departmental-Plan-Completion-Rate" || this.entity.code == "Departmental-Issue-Closure-Rate" || this.entity.code == "Departmental-Compliance-Rate") {
						Object.assign(target, this.cacheData.find(item => name === item.departmentName));
					}
					if(this.entity.code == "Plan-Completion-Rate" || this.entity.code == "Issue-Closure-Rate" || this.entity.code == "Compliance-Rate") {
						Object.assign(target, this.cacheData.find(item => name === item.month));
					}
					if(this.entity.code == "Audit-Plan" || this.entity.code == "List-of-issues") {
						Object.assign(target, this.cacheData.find(item => name === item.id));
					}
					if(this.entity.code == "Level") {
						Object.assign(target, this.cacheData.find(item => name === item.levelName));
					}
					if(this.entity.code == "Issue-Area") {
						Object.assign(target, this.cacheData.find(item => name === item.areaName));
						console.log(Object.assign(target, this.cacheData.find(item => name === item.areaName)))
					}
					if(this.entity.code == "Issue-Type") {
						Object.assign(target, this.cacheData.find(item => name === item.issueType));
					}
					if(this.entity.code == "Departmental-hidden-dangers" || this.entity.code == "Key-positions" || this.entity.code == "Hazard-closure-rate" || this.entity.code == "Year-hazard-closure-rate") {
						Object.assign(target, this.cacheData.find(item => name === item.id));
					}
					delete target.editable;
					this.tableData = newData;
				}
			},
			handleChange(value, valueList, column) {
				let newData = [...this.tableData];
				let name;
				let target;
				if(this.entity.code == "Departmental-Plan-Completion-Rate" || this.entity.code == "Departmental-Issue-Closure-Rate" || this.entity.code == "Departmental-Compliance-Rate") {
					name = valueList.departmentName;
					target = newData.find(item => name === item.departmentName);
				}
				if(this.entity.code == "Plan-Completion-Rate" || this.entity.code == "Issue-Closure-Rate" || this.entity.code == "Compliance-Rate") {
					name = valueList.month;
					target = newData.find(item => name === item.month);
				}
				if(this.entity.code == "Audit-Plan" || this.entity.code == "List-of-issues") {
					name = valueList.id;
					target = newData.find(item => name === item.id);
				}
				if(this.entity.code == "Level") {
					name = valueList.levelName;
					target = newData.find(item => name === item.levelName);
				}
				if(this.entity.code == "Issue-Area") {
					name = valueList.areaName;
					target = newData.find(item => name === item.areaName);
				}
				if(this.entity.code == "Issue-Type") {
					name = valueList.issueType;
					target = newData.find(item => name === item.issueType);
				}
				if(this.entity.code == "Departmental-hidden-dangers" || this.entity.code == "Key-positions" || this.entity.code == "Hazard-closure-rate" || this.entity.code == "Year-hazard-closure-rate") {
					name = valueList.id;
					target = newData.find(item => name === item.id);
				}
				if (target) {
					if(column == "noFinsh" || column == "finsh" || column == "finshRate" || column == "noClose" || column == "close" || column == "closeRate" || column == "issueNumber" || column == "complianceRate" || column == "id" || column == "planCount" || column == "value") {
						target[column] = Number(value);
					}else {
						target[column] = value;
					}
					this.tableData = newData;
				}
			},
		    getData() {
		        this.isLoading = true;
		        this.KanBanServiceProxy.getForEdit(
		            this.id
		        ).finally(() => {
		            this.isLoading = false;
		        }).then(res => {
					let value;
					let paramDesc;
					try {
						value = this.parseJsonArray(res.value);
						paramDesc = this.parseJsonArray(res.paramDesc);
					} catch(error) {
						abp.message.error('数据或参数结构格式错误');
						this.close();
						return;
					}
					this.entity = {
						...res,
						value,
						paramDesc
					};
					this.parameter = this.entity.paramDesc;
					
					this.columns = [];
					for(let i in this.entity.paramDesc) {
						let data = {};
						data.title = this.l(this.entity.paramDesc[i].paramName);
						// data.title = this.l(this.entity.paramDesc[i].text);
						data.dataIndex = this.entity.paramDesc[i].paramName;
						data.width = 145;
						data.align = 'center';
						data.ellipsis = true;
						data.sorter = true;
						data.scopedSlots = {customRender: this.entity.paramDesc[i].paramName};
						this.columns.push(data);
					}
					this.parameterList = [...this.columns];
					let action = {title: this.l('Action'), dataIndex: "action", width: 100, align: "center", scopedSlots: {customRender: "action"}, fixed: 'right'};
					this.columns.push(action);
					this.tableData = this.entity.value;
					if(!this.tableData) {
						this.tableData = [];
					}
					this.cacheData = this.tableData.map(item => ({ ...item }));
		        })
		    }
		}
	}
</script>

<style>
</style>
